export const excludeExternalEmailSubject = (subject = '') => {
  const regex = /(\[EXTERNAL EMAIL\])/g;
  return subject.replace(regex, '').trim();
};

export const mapInboxData = (data) => {
  return data.map(
    ({
      Body,
      MessageType,
      InternalEntityId,
      PlatformMessageId,
      ConversationId,
      DateCreated,
      DeliveredTimestamp,
      ExternalAddress,
      ExternalEntityId,
      ExternalEntityName,
      Subject,
      Direction,
      unReadCount,
      VanityName,
      Attachments,
      CallDuration,
      CallStartTimestamp,
      CallEndTimestamp,
      CallStatus,
      profileId,
      otherProfiles,
      MessageStatus,
      Read,
      contactInfo,
      lastInboundMessageIndex,
    }) => ({
      lastMessageBody: Body,
      lastMessageType: MessageType,
      internalEntityId: InternalEntityId,
      platformMessageId: PlatformMessageId,
      conversationId: ConversationId,
      dateCreated: DateCreated,
      deliveredTimestamp: DeliveredTimestamp,
      externalAddress: ExternalAddress,
      externalEntityId: ExternalEntityId,
      externalEntityName: ExternalEntityName,
      subject: Subject && excludeExternalEmailSubject(Subject),
      direction: Direction,
      unreadMessagesCount: unReadCount,
      vanityName: VanityName,
      hasAttachments: Attachments?.length > 0,
      callDuration: CallDuration,
      callStartTimestamp: CallStartTimestamp,
      callEndTimestamp: CallEndTimestamp,
      callStatus: CallStatus,
      profileId,
      otherProfiles,
      messageStatus: MessageStatus,
      readTimeStamp: Read,
      contactInfo,
      lastInboundMessageIndex,
    }),
  );
};
